import Bounds from './bounds';
import Point from './point';

/**
 * This class represents a single path from multiple points
 */
export default class Path {
    /**
     * @param {Point} points
     */
    constructor(...points) {
        if (points.length === 0) throw new Error('A path must contain at least one point');
        this.points = points;
        this.bounds = new Bounds(...points);
    }

    static fromSegment(segment) {
        return new Path(...segment.map(([, x, y]) => new Point(x, y)));
    }

    getPoints() {
        return this.points;
    }

    getBounds() {
        return this.bounds;
    }
}
